import { render, staticRenderFns } from "./HandicapRGamerData.vue?vue&type=template&id=5af6d360&scoped=true"
import script from "./HandicapRGamerData.vue?vue&type=script&lang=js"
export * from "./HandicapRGamerData.vue?vue&type=script&lang=js"
import style0 from "./HandicapRGamerData.vue?vue&type=style&index=0&id=5af6d360&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af6d360",
  null
  
)

export default component.exports